import {
  HIDE_MEDIA_BUYER_PLANS_LOADER,
  SET_MEDIA_BUYER_PLANS,
  SET_MEDIA_BUYER_PLAN_FOR_ID,
  SHOW_MEDIA_BUYER_PLANS_LOADER,
  SET_ERROR_MEDIA_BUYER_PLANS,
  SET_PLANS_OFFER,
  SHOW_MEDIA_BUYER_PLANS_PARAMS_LOADER,
  HIDE_MEDIA_BUYER_PLANS_PARAMS_LOADER,
  SET_MEDIA_BUYER_PLANS_FILTER_DATA,
  SHOW_MEDIA_BUYER_PLANS_FILTER_DATA_LOADER,
  HIDE_MEDIA_BUYER_PLANS_FILTER_DATA_LOADER,
  SET_MEDIA_BUYER_PROFIT,
  PROFIT_LOADING_PROCESS,
  SET_MEDIA_BUYER_PLANS_PROFIT_FILTER_DATA,
  SET_PAYOUT_CONDITIONS_MEDIA_BUYER,
  PAYOUT_LOADER_MEDIA_BUYER,
} from "./actionType";
import { getInitialDate } from "../../../helpers/utils";

const INIT_STATE = {
  data: {
    next: null,
    previous: null,
    page: 1,
    size: 10,
    results: [],
  },
  payoutData: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  payout_loader: false,
  client_plan: null,
  loading: false,
  error: null,
  offer: null,
  paramsLoader: true,
  filterData: {
    options: [],
    value: [],
    planned_sum_from: null,
    planned_sum_to: null,
    getData: function (key) {
      return {
        [key]: this.value.map(i => i.value),
        planned_sum_from: this.planned_sum_from,
        planned_sum_to: this.planned_sum_to,
      };
    },
  },
  profitFilterData: {
    date_from: getInitialDate("start_date"),
    date_to: getInitialDate("end_date"),
  },
  profit_data: {
    results: [],
  },
  profit_loading: false,
  isLoadingFilterData: false,
};

const MediaBuyerPlans = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_MEDIA_BUYER_PLANS_PROFIT_FILTER_DATA:
      return {
        ...state,
        profitFilterData: { ...state.profitFilterData, ...action.payload },
      };
    case SHOW_MEDIA_BUYER_PLANS_FILTER_DATA_LOADER:
      return {
        ...state,
        isLoadingFilterData: true,
      };
    case HIDE_MEDIA_BUYER_PLANS_FILTER_DATA_LOADER:
      return {
        ...state,
        isLoadingFilterData: true,
      };
    case SET_MEDIA_BUYER_PLANS_FILTER_DATA:
      return {
        ...state,
        filterData: {
          ...state.filterData,
          ...action.payload,
        },
      };
    case SET_PLANS_OFFER:
      return {
        ...state,
        offer: action.payload,
      };
    case SHOW_MEDIA_BUYER_PLANS_PARAMS_LOADER:
      return {
        ...state,
        paramsLoader: true,
      };
    case HIDE_MEDIA_BUYER_PLANS_PARAMS_LOADER:
      return {
        ...state,
        paramsLoader: false,
      };
    case SET_MEDIA_BUYER_PLANS:
      return {
        ...state,
        data: action.payload,
      };
    case SET_MEDIA_BUYER_PLAN_FOR_ID:
      return {
        ...state,
        client_plan: action.payload,
      };
    case SHOW_MEDIA_BUYER_PLANS_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_MEDIA_BUYER_PLANS_LOADER:
      return {
        ...state,
        loading: false,
      };
    case SET_ERROR_MEDIA_BUYER_PLANS:
      return {
        ...state,
        isError: action.payload,
      };
    case PROFIT_LOADING_PROCESS:
      return {
        ...state,
        profit_loading: !state.profit_loading,
      };
    case SET_MEDIA_BUYER_PROFIT:
      return {
        ...state,
        profit_data: action.payload,
      };
    case SET_PAYOUT_CONDITIONS_MEDIA_BUYER: {
      return {
        ...state,
        payoutData: action.payload,
      };
    }
    case PAYOUT_LOADER_MEDIA_BUYER: {
      return {
        ...state,
        payout_loader: !state.payout_loader,
      };
    }
    default:
      return state;
  }
};

export default MediaBuyerPlans;
